function focusElement(focusElements, numberInitialElementsIgnored) {
  for (let index = 0; index < focusElements.length; index++) {
    focusElements[index].setAttribute('data-focus-state', false);
  }
  for (let index = numberInitialElementsIgnored; index < focusElements.length; index++) {
    if (
      !focusElements[index].disabled ||
      focusElements[index].getAttribute('disabled') === 'false'
    ) {
      focusElements[index].focus();
      focusElements[index].scrollIntoView &&
        focusElements[index].scrollIntoView({ behavior: 'smooth' });
      focusElements[index].setAttribute('data-focus-state', true);
      break;
    }
  }
}

export async function updateFocusComponents({
  numberInitialElementsIgnored = 0,
  documentContent = document,
  tagNameElementHTML,
  delay = 0
}) {
  const focusElements = documentContent.getElementsByTagName(tagNameElementHTML);
  if (
    focusElements &&
    focusElements.length > 0 &&
    focusElements.length > numberInitialElementsIgnored
  ) {
    if (delay > 0) {
      setTimeout(() => {
        focusElement(focusElements, numberInitialElementsIgnored);
      }, delay);
      return;
    }
    focusElement(focusElements, numberInitialElementsIgnored);
  }
}
